import { render, staticRenderFns } from "./ModalEditReasignacion.vue?vue&type=template&id=4c0f1704&scoped=true&"
import script from "./ModalEditReasignacion.vue?vue&type=script&lang=ts&"
export * from "./ModalEditReasignacion.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEditReasignacion.vue?vue&type=style&index=0&id=4c0f1704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f1704",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c0f1704', component.options)
    } else {
      api.reload('4c0f1704', component.options)
    }
    module.hot.accept("./ModalEditReasignacion.vue?vue&type=template&id=4c0f1704&scoped=true&", function () {
      api.rerender('4c0f1704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ReasignacionEquipos/ModalEditReasignacion.vue"
export default component.exports